import React from "react";
import Intro from "../../component/Intro";
import ContactForm from "../../component/Contact/ContactComp";
import Footer from "../../component/footer";

function Contacts({ setmymode, mode }) {
  const textinline = {
    headh1: "Contact",
    spano: "Us",
    subh1:
      "Your Digital Solution Partner, We turn ideas into extraordinary digital products.",
    paragraph1:
      "Your premier digital agency for cutting-edge web development and online solutions. We are here to help you achieve your digital goals with expertise and innovation.",
  };
  return (
    <div>
      <Intro mode={mode} setmymode={setmymode} textinline={textinline} />
      <ContactForm />
      <Footer />
    </div>
  );
}

export default Contacts;
